import { render, staticRenderFns } from "./OnAcces.vue?vue&type=template&id=61097202&"
import script from "./OnAcces.vue?vue&type=script&lang=js&"
export * from "./OnAcces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports